export type sortingOrder =
  | 'relevance_desc'
  | 'price_desc'
  | 'price_asc'
  | 'created_at_asc'
  | 'discount_desc'
  | 'new_arrivals_desc'
  | 'score_top_seller_desc'
  | 'user_rating_desc';

export const isSortingOrder = (value: unknown): value is sortingOrder => {
  if (typeof value !== 'string') return false;
  return [
    'relevance_desc',
    'price_desc',
    'price_asc',
    'created_at_asc',
    'discount_desc',
    'new_arrivals_desc',
    'score_top_seller_desc',
    'user_rating_desc'
  ].includes(value);
};

export type reducerActions =
  | 'checkFilter'
  | 'clearFilters'
  | 'selectRadio'
  | 'setCurrentPage'
  | 'setCurrentSortingOrder'
  | 'uncheckFilter'
  | 'update';

export type reducerFunctions = {
  setCurrentSortingOrder: (sortingOrder: sortingOrder) => void;
  clearFilters: () => void;
  checkFilter: ({ section, option }: { section: string; option: string }) => void;
  uncheckFilter: ({ section, option }: { section: string; option: string }) => void;
  selectRadio: ({ section, option }: { section: string; option: string }) => void;
  setCurrentPage: (page: number) => void;
};
